module.exports = __webpack_public_path__ + "static/img/indexSoftware3.4958bd8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/indexSoftware3.png
// module id = ZtIH
// module chunks = 2